export default function() {
    if (!document.querySelector('[data-trigger-cross-sells]')) {
        return
    }

    document.getElementById('product-upsell')?.showModal()
}
